import script from "./BaseInfoGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInfoGroup.vue?vue&type=script&setup=true&lang=js"

import "./BaseInfoGroup.vue?vue&type=style&index=0&id=36f304ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f304ea"]])

export default __exports__